import initializeApp from 'apps/cart/desktop/overview/app';
import { declareJavaScriptInitialized, deleteSessionStorage } from 'utilities/browser';
import { domReady } from 'utilities/dom';
import { Reporter, visibilityObserver } from 'features/dataCapture';
import { utagViewArtificialPageView, utagLinkCart } from 'features/tealium';
import { setGenericEvent } from 'features/tealium/ga4/custom';
import { prefetchWebpackAssetSet } from 'features/webpack';
import { initStickyHeaderSearch } from 'features/stickyHeaderSearch';
import { trackDyRecommendedItemClickEvent } from 'features/tealium/dynamicYield/recommendedItemsTracking';

const trackArtificialPageView = utagViewArtificialPageView();
const trackCartEvents = utagLinkCart();

domReady(() => {

	$('.workWithDs').on('click', (e) => {

		e.preventDefault();

		trackCartEvents({
			eventAction: 'Click-Design-Specialist'
		});

		window.lp.utils.openWorkWithAgentModal({
			closeEvt () {

				// if assetsAreShared this will refresh the page.
				window.parent.$(window.parent.lp).trigger('closeModalShareWithCSR');
				trackArtificialPageView({ pageName: '' });

			}
		});

	});

	const csrContinueShoppingLink = document.querySelector('.continueShopping');

	if (csrContinueShoppingLink) {

		csrContinueShoppingLink.addEventListener('click', () => {

			setGenericEvent({ event_name: 'cart_shop_click' });

		});

	}

	// Certona
	if (window.lp.globals.canShowCertona) {

		window.lp.certona.getRecommendedItems();

		if (window.lp.globals.enableDataCapture) {

			const observeAndTrackElements = (elements) => {

				if (elements.length > 0) {

					const { reporter } = window.lp.dataCapture;
					const observer = visibilityObserver((element) => {

						const data = Reporter.getSkuViewData(element);
						reporter.track(data);

					});
					elements.forEach((element) => observer.observe(element));

				}

			};

			document.addEventListener('recommendedItems:cart:loaded', () => {

				observeAndTrackElements(document.querySelectorAll('[data-capture-section="MoreYouMayLikeWidget"] img'));

			});

		}

		document.addEventListener('recommendedItems:cart:loaded', () => {

			const moreYouMayLikeWidget = document.querySelectorAll('[data-capture-section="MoreYouMayLikeWidget"] a');
			if (moreYouMayLikeWidget.length) {

				trackDyRecommendedItemClickEvent({ selector: moreYouMayLikeWidget });

			}

		});

	}

	// Remove sort page searchSkuCount from the session after using this value in Utag_data.
	if (sessionStorage.getItem('searchSkuCount')) {

		deleteSessionStorage('searchSkuCount');

	}

	initStickyHeaderSearch();

	initializeApp().finally(() => declareJavaScriptInitialized('page'));

	prefetchWebpackAssetSet('desktop/cart/shipping');

});
